<app-admin-list-page [title]="'Match test' | translate">

  <ul class="nav nav-pills mt-3">
    <li class="nav-item">
      <a class="nav-link cursor-pointer" [class.active]="activeTab === 'competencies'" (click)="activeTab = 'competencies'">
        {{'Competencies' | translate}}
      </a>
    </li>
    <li class="nav-item">
      <a class="nav-link cursor-pointer" [class.active]="activeTab === 'questions'" (click)="activeTab = 'questions'">
        {{'Questions' |  translate}}
      </a>
    </li>
  </ul>

  <div class="tab-content">

    <div id="tab-matchtestcompetencies" class="tab-pane" [class.active]="activeTab === 'competencies'" [class.d-none]="activeTab !== 'competencies'">

      <div class="mb-3">
        <button class="btn btn-primary" (click)="addMatchtestCompentency()">
          {{'Add' | translate}}
        </button>
      </div>

      <app-table [config]="tableConfigCompetencies" (buttonEvent)="handleButtonEvent($event, 'matchcompetency')"></app-table>

    </div>

    <div id="tab-matchtestquestions" class="tab-pane" [class.active]="activeTab === 'questions'" [class.d-none]="activeTab !== 'questions'">

      <div class="mb-3">
        <button class="btn btn-primary" (click)="addMatchtestQuestion()">
          {{'Add' | translate}}
        </button>
      </div>

      <app-table [config]="tableConfigQuestions" (buttonEvent)="handleButtonEvent($event, 'matchquestion')"></app-table>

    </div>

  </div>

</app-admin-list-page>
